import gql from 'graphql-tag';

import { SceneLightWithState } from '@/queries/fields/sceneLightFields';

export namespace SceneWithLights {

  export const fragment = gql`
    fragment scenesFieldsWithoutDates on Scene {
      id
      floorId
      roomId
      name
      imageUrl
      lights {
        ...sceneLightFields
      }
    }
  `;

  export interface Definition {
    id: string;
    floorId: string;
    roomId: string;
    name: string;
    imageUrl?: string;
    lights: SceneLightWithState.Definition[];
  }

}

export default gql`
  fragment scenesFields on Scene {
    id
    floorId
    roomId
    name
    imageUrl
    updateDate
    creationDate
    lights {
      id
      lightId
      status
      dimming
      speed
      ratio
      mode {
        ...lightModeFields
      }
    }
  }
`;
